module.exports = __webpack_public_path__ + "img/simulator-sisu.3e37b2ec.png";